import { EncryptionAccessLogMapEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const EncryptionAccessLogMapResource = authResource({
    path: '/encryptions/:encryptionId/accessmap/:accessMapId?',
    schema: EncryptionAccessLogMapEntity
}).extend('getList', {
    schema: paginatedSchema(EncryptionAccessLogMapEntity)
});
